import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// @ts-ignore
import Flag from 'react-world-flags';

type LanguageType = {
  code: string;
  flagCode: Flag;
  title: string;
};

const languages: LanguageType[] = [
  {
    code: 'en',
    flagCode: 'us',
    title: 'English',
  },
  {
    code: 'de',
    flagCode: 'de',
    title: 'Deutsch',
  },
];

export function LanguagePicker() {
  const { i18n } = useTranslation();

  const changeLanguage = (lang: any) => {
    i18n.changeLanguage(lang);
  };

  const getActiveLanguageDisplay = () => {
    let activeLang = languages.find((l) => l.code === i18n.language);
    if (activeLang) return <Flag code={activeLang.flagCode} height={16} />;
    return '';
  };

  return (
    <div className="d-flex d-flex-sh align-items-center justify-content-center">
      <Dropdown onSelect={changeLanguage}>
        <Dropdown.Toggle
          variant={'secondary'}
          className="d-flex align-items-center justify-content-center pt-2 pb-2"
        >
          {getActiveLanguageDisplay()}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {languages.map((value, index) => (
            <Dropdown.Item
              key={index}
              eventKey={value.code}
              active={value.code === i18n.language}
              className="d-flex align-items-center"
            >
              <Flag code={value.flagCode} height={16} className="me-2" />
              {value.title}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
